// @ts-check
import { defineConfig } from '../utils';

export function boxReadings() {
  return defineConfig({
    properties: {
      'RegistroCajas.MostrarTrabajadores': {
        defaultValue: false,
      },
    },
  });
}
